import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import facultyData from "../UG/facultyData/mechanicalFacultyData";

export const programme = {
  id: "me-research",
  name: "Mechanical Engineering Research Centre",
  short: "ME Research Centre",
  programmeType: "research",
  programmeLabel: "Research Centre",
  duration: "Ph.D. / M.Sc. (Engg.) by Research",
  established: "2014-15",
  hodId: "f-k-s-pujari",
  facultyData,
  facultyDeptId: "me",
  hideFacultySection: true,
  hideSharedClubs: true,

  description:
    "The Department of Mechanical Engineering is recognized as a VTU Research Centre and offers Ph.D. and M.Sc. (Engineering) by Research programmes affiliated to Visvesvaraya Technological University, Belagavi. Faculty members are actively involved in research in thermal and fluids engineering, lean manufacturing, jet impingement, advanced manufacturing, and allied mechanical engineering domains.",

  image: "/HomePage/dept/mech.jpeg",

  labs: [
    "CAD/CAM Lab",
    "Thermodynamics Lab",
    "Fluid Mechanics Lab",
    "Manufacturing Workshop",
    "Research Computing Facility",
  ],

  dashboard: [
    ["Recognized Since", "2014-15"],
    ["Research Areas", "05"],
    ["Research Supervisors", "05"],
    ["Research Scholars", "05"],
  ],

  quickFacts: [
    ["Established", "2014-15"],
    ["Programme", "Ph.D. / M.Sc. (Engg.) by Research"],
    ["Research Supervisors", "05"],
    ["Research Scholars", "05"],
    ["Research Areas", "Thermal Engineering, Fluid Mechanics, Lean Manufacturing, Jet Impingement"],
    ["Affiliation", "VTU, Belagavi"],
  ],

  academicOverview: [
    {
      title: "Research Centre Overview",
      text:
        "The Mechanical Engineering Research Centre supports doctoral and M.Sc. (Engineering) research through faculty supervision, laboratory facilities, modelling tools, experimentation, and scholarly publication activity.",
    },
    {
      title: "Research Facilities",
      text:
        "The department provides access to CAD/CAM, thermodynamics, fluid mechanics, manufacturing, and workshop facilities that support experimental studies, modelling, product development, and advanced mechanical engineering research.",
    },
    {
      title: "Research Culture",
      text:
        "Faculty members publish research papers in reputed journals, present work at national and international forums, guide project activity, and promote innovation across manufacturing and thermal systems.",
    },
  ],

  curriculumSupport: [
    "Ph.D. and M.Sc. (Engineering) by Research guidance",
    "Experimental research and laboratory testing support",
    "CAD/CAM modelling and simulation activities",
    "Manufacturing and prototype development",
    "Journal publication and conference presentation support",
    "Project proposal and funded research guidance",
    "Interdisciplinary research collaboration",
    "Technical documentation support",
  ],

  researchAreas: [
    "Thermal Engineering",
    "Fluid Mechanics",
    "Lean Manufacturing",
    "Jet Impingement",
    "Advanced Manufacturing",
  ],

  infrastructure: [
    ["CAD/CAM Lab", "Available"],
    ["Thermodynamics Lab", "Available"],
    ["Fluid Mechanics Lab", "Available"],
    ["Manufacturing Workshop", "Available"],
    ["Research Support", "Experimentation, modelling, and prototype development"],
  ],

  achievements: [
    "Recognized as a VTU Research Centre.",
    "Offers Ph.D. and M.Sc. (Engineering) by Research programmes.",
    "Faculty members publish in reputed journals and present at national and international conferences.",
    "Research activity spans manufacturing, thermal systems, and fluid engineering.",
  ],

  supervisors: [
    ["Dr. K. S. Pujar", "Research Supervisor", "f-k-s-pujari"],
    ["Dr. Shankar Badiger", "Research Supervisor", "f-shankar-badiger"],
    ["Dr. Anant Joshi", "Research Supervisor", "f-anant-g-joshi"],
    ["Dr. Shailesh Channapattana", "Research Supervisor", null, "/FacultyCImages/Dr. Shailesh Channapattana.png"],
    ["Dr. Gururaj Hatti", "Research Supervisor", "f-gururaj-hatti"],
  ],

  researchScholars: [
    ["Mr. Sudhir D. Kulkarni", "Research Scholar", "f-sudhir-d-kulkarni"],
    ["Mr. Gurunath Mewundi", "Research Scholar", "f-gurunath-mewundi"],
    ["Mrs. Prajakta Patil", "Research Scholar", null, false],
    ["Mr. Naveen C. S", "Research Scholar", "f-naveen-s-hiremath", false],
    ["Mr. Abid Mulla", "Research Scholar", null, false],
  ],
};

const MechanicalResearchCentre = () => <ProgrammeDetail programme={programme} />;

export default MechanicalResearchCentre;
